import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


const indianStates = [
  "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
  "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand",
  "Karnataka", "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur",
  "Meghalaya", "Mizoram", "Nagaland", "Odisha", "Punjab",
  "Rajasthan", "Sikkim", "Tamilnadu", "Telangana", "Tripura",
  "Uttar Pradesh", "Uttarakhand", "West Bengal", "Delhi", "Puducherry"
];

function Statewise() {
  const [ads, setAds] = useState([]);

  const sliderSettings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  useEffect(() => {
    const fetchAds = async () => {
      try {
        const res = await fetch("https://backend-zkgn.onrender.com/api/banners/sidebanner");
        const data = await res.json();
        if (data && Array.isArray(data)) {
          setAds(data);
        }
      } catch (err) {
        console.error("Failed to fetch ads:", err);
      }
    };

    fetchAds();
  }, []);

  return (
    <div className="container-fluid my-5 py-4 statewise-wrapper">
      <div className="row">
        {/* Left Column - States */}
        <div className="col-lg-12 col-md-12 mb-4 mb-lg-0">
          <h2 className="statewise-heading mb-3">
            Statewise Cogen Powerplants in India
          </h2>
          <div className="state-list">
            {indianStates.map((state, index) => (
              <Link
                className="state-link"
                to={`/state/${encodeURIComponent(state)}`}
                key={index}
              >
                {state}
              </Link>
            ))}
          </div>
        </div>

        {/* Right Column - Ad Slider */}
        {/* <div className="col-lg-6 col-md-12">
          <div className="ad-slider shadow-sm">
            {ads.length > 0 ? (
              <Slider {...sliderSettings}>
                {ads.map((banner) => (
                  <div key={banner.banner_id} className="ad-slide">
                    <a
                      href={banner.website}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={`https://backend-zkgn.onrender.com/uploads/${banner.banner_image_link}`}
                        alt={banner.supplier_name}
                        className="img-fluid ad-img"
                        loading="lazy"
                        onError={(e) => {
                          e.target.src = "/fallback.jpg";
                        }}
                      />
                    </a>
                  </div>
                ))}
              </Slider>
            ) : (
              <p className="text-center text-muted my-3">No ads available</p>
            )}
          </div>
        </div> */}
      </div>
    </div>
  );
}

export default Statewise;
